import React from "react";
import classnames from "classnames";
import SpokenLanguageList from "../lists/SpokenLanguageList";
import ExpandableList from "../lists/ExpandableList";
import Grid from "../../components/grid/Grid";
import Map from "../../components/map/Map";
import CustomLink from "../../components/links/CustomLink";
import cssClass from "./ClinicDetails.module.scss";
import ClinicPhotoGallery from "./ClinicPhotoGallery";

const ClinicDetails = ({
  className,
  gallery,
  location,
  pregnancyRateIvf,
  pregnancyRateIvfIcsi,
  testimonial,
  treatments,
  techniques,
  otherServices,
  spokenLanguages,
  email,
  address,
  officeHours,
  phone,
  getDirectionsLink,
  pregnancyRatesTitle,
  pregnancyRatesSubtitle,
  ivfTitle,
  ivfAverage,
  ivfIcsiTitle,
  ivfIcsiAverage,
  nationalAverageTitle,
  nationalAverageExtra,
  offeringsTitle,
  treatmentsTitle,
  techniquesTitle,
  otherServicesTitle,
  contactTitle,
  locationTitle,
  officeHoursTitle,
  telephoneNumbersTitle,
  emailTitle,
  internationalPhone,
}) => {
  return (
    <div className={classnames(cssClass.detailsContainer, className)}>
      {gallery && <ClinicPhotoGallery images={gallery} />}
      {(pregnancyRateIvf || pregnancyRateIvfIcsi) && (
        <div className={cssClass.statsContainer}>
          <h3>{pregnancyRatesTitle}</h3>
          <p className={cssClass.subtitle}>{pregnancyRatesSubtitle}</p>
          <Grid columns={2}>
            {pregnancyRateIvf && (
              <div>
                <p className="boldText">{ivfTitle}</p>
                <div className={cssClass.statistic}>{pregnancyRateIvf}</div>
                <div className={cssClass.statisticAverage}>{ivfAverage}</div>
                <p className="smallBodyText">{nationalAverageTitle}</p>
              </div>
            )}
            {pregnancyRateIvfIcsi && (
              <div>
                <p className="boldText">{ivfIcsiTitle}</p>
                <div className={cssClass.statistic}>{pregnancyRateIvfIcsi}</div>
                <div className={cssClass.statisticAverage}>
                  {ivfIcsiAverage}
                </div>
                <p className="smallBodyText">{nationalAverageTitle}</p>
              </div>
            )}
          </Grid>
          <p className={cssClass.statsFootnote}>{nationalAverageExtra}</p>
        </div>
      )}
      {testimonial && (
        <div className={cssClass.quoteContainer}>
          <blockquote>{testimonial}</blockquote>
        </div>
      )}
      {(treatments || techniques || spokenLanguages) && (
        <div className={cssClass.unitsContainer}>
          <h3>{offeringsTitle}</h3>
          <Grid columns={2}>
            {treatments && (
              <ExpandableList
                title={treatmentsTitle}
                stringArray={treatments}
              />
            )}
            {techniques && (
              <ExpandableList
                title={techniquesTitle}
                stringArray={techniques}
              />
            )}
            {otherServices && (
              <ExpandableList
                title={otherServicesTitle}
                stringArray={otherServices}
              />
            )}
            {spokenLanguages && (
              <SpokenLanguageList spokenLanguagesArray={spokenLanguages} />
            )}
            {/* HIDDEN UNTIL MORE INFO IS READY FOR INSURANCE PARTNERS */}
            {/* {insurancePartners && (
            <div>
              <p className="boldText">Insurance Partners</p>
              <ul
                className={classnames(
                  cssClass.noListStyle,
                  cssClass.insurancePartnerLogoList
                )}
              >
                {insurancePartners.map((partner) => (
                  <li key={partner.id}>
                    <Img
                      className={cssClass.insurancePartnerLogo}
                      fluid={partner.fluid}
                      alt={partner.title}
                    />
                  </li>
                ))}
              </ul>
            </div>
          )} */}
          </Grid>
        </div>
      )}
      {location && (
        <div className={cssClass.mapWrapper}>
          <Map
            position={[location.lat, location.lon]}
            tag={
              <div
                dangerouslySetInnerHTML={{
                  __html: address.childMarkdownRemark.html,
                }}
              />
            }
          />
        </div>
      )}
      <div className={cssClass.contactContainer}>
        <h3>{contactTitle}</h3>
        <Grid columns={2}>
          {address && (
            <div>
              <p className="boldText">{locationTitle}</p>
              <div
                dangerouslySetInnerHTML={{
                  __html: address.childMarkdownRemark.html,
                }}
              />
              <CustomLink to="/" style="directions">
                {getDirectionsLink}
              </CustomLink>
            </div>
          )}
          {phone && (
            <div>
              <p className="boldText">{telephoneNumbersTitle}</p>
              <p>
                <span className="boldText">{phone}</span>
              </p>
              {internationalPhone && (
                <p>
                  Other countries: <br />
                  <span className="boldText">{internationalPhone}</span>
                </p>
              )}
            </div>
          )}
          {officeHours && (
            <ExpandableList
              title={officeHoursTitle}
              stringArray={officeHours}
            />
          )}
          {email && (
            <div>
              <p className="boldText">{emailTitle}</p>
              <a
                href={`mailto:${email}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {email}
              </a>
            </div>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default ClinicDetails;
